<template>
    <div v-if="isCmsTool">
        <img
            v-if="data.name === ComponentRefNames.MapMarkers"
            src="@/assets/map/map_ref_section.png"
            alt="Karte mit Markers Bild"
            class="img-fluid"
        />

        <!-- Not necessary for the time being to support other component ref section names  -->
    </div>
</template>

<script>
import ComponentRefContentType from 'cms/models/contentTypes/ComponentRef';
import { ComponentRefNames } from 'cms/models/contentTypes/ComponentRef';

export default {
    name: 'ComponenrRefContentType',

    data() {
        return {
            ComponentRefNames
        };
    },

    props: {
        data: {
            type: [Object, ComponentRefContentType],
            required: true
        }
    },

    computed: {
        isCmsTool() {
            return this.$cmsTool;
        }
    }
};
</script>
